<template>
  <div>
    <Panel
      :module="panel.module"
      :title="panel.title"
      :showFilter="panel.showFilter"
      :showSearch="panel.showSearch"
      :showButtons="panel.showButtons"
    >
      <div slot="content-main">
        <br />
        <NotificationMain />
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";
import NotificationMain from "../components/NotificationMain.vue";

import { mapMutations } from "vuex";

export default {
  name: "NotificationView",
  components: { Panel, NotificationMain },
  data() {
    return {
      panel: {
        module: "Adm",
        title: "Notificação",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  },
};
</script>

<style scoped>
</style>
